import * as React from 'react';
import axios from "axios";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { red } from "@mui/material/colors";
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Rating from '@mui/material/Rating';
import Switch from '@mui/material/Switch';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import CircularProgress from '@mui/material/CircularProgress';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';

import AdminMenuComponent from "../../../components/admin/AdminMenuComponent.js";

import { strDateITAfromDayJs, strDateUSAfromDayJs, strDateITAfromStrUSA, strDateUSAfromStrITA } from '../../../utils/dateUtils.js'
const { strCurrency, strEuroCurrency } = require('../../../utils/currencyUtils.js')

const config = require("../../../constants/constants.js")

const EditPaymentPageComponent = ({ updatePaymentApiRequest, fetchPayment }) => {

  const [validated, setValidated] = useState(false);
  const [payment, setPayment] = useState([]);
  const [updatePaymentResponseState, setUpdatePaymentResponseState] = useState({ payment: "", error: "" });

  const { id } = useParams();
  const navigate = useNavigate();

  const [amount, setAmount] = useState(0);                      
  const [date, setDate] = useState("");                      
  const [hour, setHour] = useState(""); 
  const [cardName, setCardName] = useState(""); 
  const [product, setProduct] = useState(""); 
  const [category, setCategory] = useState(""); 
  const [cardBrand, setCardBrand] = useState(""); 
  const [cardLast4, setCardLast4] = useState(""); 
  
  useEffect(() => {
    fetchPayment(id)
    .then(data => {
      console.log(`data =`, data);  
      setAmount(data?.amount);
      setDate(data?.date);
      setHour(data?.hour);
      setCardName(data?.card.name);
      setProduct(data?.productDescription);
      setCategory(data?.categoryDescription);
      setCardBrand(data?.card.brand);
      setCardLast4(data?.card.last4);

      console.log(`amount  =`, amount);  
      console.log(`date  =`, date);  
    })
    .catch((er) => console.log(er.response.data.message ? er.response.data.message : er.response.data));         
  },[id])


  function salvaPaymentModificata (eventKey) {
  eventKey.preventDefault();
  eventKey.stopPropagation();

  /*
  console.log(`title dig =`, title);  
  console.log(`name dig =`, name);  
  console.log(`surname dig =`, surname);  
  console.log(`telephone dig =`, telephone);  
  console.log(`email dig =`, email);  
  console.log(`address dig =`, address);  
  console.log(`code dig =`, code);  
  console.log(`color dig =`, color);  
  console.log(`image dig =`, image);  

  updatePaymentApiRequest(id, title, name, surname, telephone, email, address, code, color, image)
  .then(data => {
      if (data.success === "payment updated") {
          navigate("/admin/payments");
      }
    })
  .catch(er => {
      setUpdatePaymentResponseState({ error: er.response.data.message ? er.response.data.message : er.response.data });
  })
  */

  window.location.assign('/admin/payments')
}

function gotoIndietro (eventKey) {
  eventKey.preventDefault();
  eventKey.stopPropagation();

  window.location.assign('/admin/payments')
}

  return (

    <Box sx={{ flexGrow: 1 }}>

      <Grid container spacing={2}>

        <AdminMenuComponent></AdminMenuComponent>

        <Box
          paddingLeft={{ xs: 3, md: 3 }}
        >

          <Breadcrumbs separator="›" aria-label="breadcrumb"
            size={{ xs: 12, md: 4 }}
            paddingTop={{ xs: 3, md: 3 }}
            paddingLeft={{ xs: 0, md: 0 }}
            paddingRight={{ xs: 1, md: 8 }}
            spacing={{ xs: 2, md: 2 }}
          >
            <Link underline="hover" color="inherit" href="">
              {config.BC_ADMIN}
            </Link>
            <Link underline="hover" color="inherit" href="/admin/payments">
              {config.BC_ADMIN_MESSAGES}
            </Link>
            <Typography sx={{ color: 'text.primary' }}>{config.BC_ADMIN_MESSAGES_VIEW}</Typography>
          </Breadcrumbs>

          <Stack
            sx={{ flexDirection: { xs: "row", md: "row" }, paddingTop: 2, paddingLeft: 0, paddingRight: 0, }}
          >

            <Typography
              sx={{ paddingTop: 0, paddingLeft: 0, paddingRight: 0, }}
              variant="h4"
            >
              <b>Dettagli pagamento</b>&nbsp;
            </Typography>

          </Stack>

          <Box
            sx={{
              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
              height: 20
            }}
          />

          <Paper
            sx={{
              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
              background: '#cce0e6'
            }}
            elevation={6}
          >

            <Stack
              useFlexGap
              sx={{
                flexDirection: { xs: "column", md: "row" },
                paddingTop: 2, paddingLeft: 0, paddingRight: 0,
                flexWrap: 'wrap'
              }}
            >

              <TextField id="id-amount" label="Importo" variant="outlined" value={strEuroCurrency(amount)} defaultValue={strEuroCurrency(amount)}
                style={{
                  width: "150px",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                InputProps={{
                  readOnly: true,
                }}
                onChange={(event) => {
                  setAmount(event.target.value);
                }}
              />

              <TextField id="id-date" label="Data" variant="outlined" value={strDateITAfromStrUSA(date)} defaultValue={strDateITAfromStrUSA(date)}
                style={{
                  width: "150px",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                InputProps={{
                  readOnly: true,
                }}
                onChange={(event) => {
                  setDate(event.target.value);
                }}
              />

              <TextField id="id-hour" label="Ora" variant="outlined" value={hour} defaultValue={hour} 
                style={{
                  width: "150px",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                InputProps={{
                  readOnly: true,
                }}
                onChange={(event) => {
                  setHour(event.target.value);
                }}
              />

              <TextField id="id-cardName" label="Eseguito da" variant="outlined" value={cardName} defaultValue={cardName} 
                style={{
                  width: "400px",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                InputProps={{
                  readOnly: true,
                }}
                onChange={(event) => {
                  setCardName(event.target.value);
                }}
              />

              <TextField id="id-product" label="Prodotto acquistato" variant="outlined" value={product} defaultValue={product} 
                style={{
                  width: "300px",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                InputProps={{
                  readOnly: true,
                }}
                onChange={(event) => {
                  setProduct(event.target.value);
                }}
              />

              <TextField id="id-category" label="Categoria" variant="outlined" value={category} defaultValue={category} 
                style={{
                  width: "300px",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                InputProps={{
                  readOnly: true,
                }}
                onChange={(event) => {
                  setCategory(event.target.value);
                }}
              />

              <TextField id="id-cardBrand" label="Tipo carta" variant="outlined" value={cardBrand} defaultValue={cardBrand} 
                style={{
                  width: "150px",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                InputProps={{
                  readOnly: true,
                }}
                onChange={(event) => {
                  setCardBrand(event.target.value);
                }}
              />

              <TextField id="id-numcarta" label="Numero" variant="outlined" value={'***'+cardLast4} defaultValue={'***'+cardLast4} 
                style={{
                  width: "100px",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
                InputProps={{
                  readOnly: true,
                }}
                onChange={(event) => {
                  setCardBrand(event.target.value);
                }}
              />

            </Stack>

            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: "row", md: "row" },
                alignItems: "center",
                justifyContent: "center"
              }}
            >

              <Button
                type="button"
                variant="contained"
                color="warning"
                onClick={(e) => { gotoIndietro(e); }}
                sx={{
                  width: "12ch",
                  p: { xs: 1, md: 1 },
                  m: { xs: 1, md: 1 },
                }}
              >
                Indietro
              </Button>

            </Box>

            <Box
              sx={{
                paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
                height: 20
              }}
            />

          </Paper>

          <Box
            sx={{
              paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 0,
              height: 40
            }}
          />

        </Box>

      </Grid>



    </Box>

  );
};

export default EditPaymentPageComponent;
